var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5004 41.8L29.1004 4C28.3004 2.4 26.7004 1.5 25.0004 1.5C23.3004 1.5 21.7004 2.5 20.9004 4L1.5004 41.8C0.800397 43.3 0.800397 44.9 1.7004 46.3C2.6004 47.7 4.0004 48.5 5.7004 48.5H44.4004C46.0004 48.5 47.5004 47.7 48.4004 46.3C49.2004 44.9 49.2004 43.3 48.5004 41.8ZM46.6004 45.3C46.1004 46.1 45.3004 46.6 44.3004 46.6H5.6004C4.7004 46.6 3.8004 46.1 3.4004 45.3C3.0004 44.5 2.9004 43.5 3.3004 42.7L22.7004 4.9C23.1004 4 24.0004 3.5 25.0004 3.5C26.0004 3.5 26.9004 4 27.4004 4.9L46.8004 42.7C47.1004 43.5 47.1004 44.5 46.6004 45.3Z",
    fill: "#CD2424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2008 20.1004C29.2008 20.2004 28.3008 33.1004 25.0008 33.1004C21.7008 33.1004 20.8008 20.2004 20.8008 20.1004C20.8008 17.8004 22.7008 15.9004 25.0008 15.9004C27.3008 15.9004 29.2008 17.8004 29.2008 20.1004Z",
    fill: "#CD2424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 41.5002C26.6012 41.5002 27.8996 40.2018 27.8996 38.6002C27.8996 36.9986 26.6012 35.7002 24.9996 35.7002C23.398 35.7002 22.0996 36.9986 22.0996 38.6002C22.0996 40.2018 23.398 41.5002 24.9996 41.5002Z",
    fill: "#CD2424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.7fbf1227f9a58669e8a7545fe07338f4.svg";
export { ForwardRef as ReactComponent };